// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testAttributeLineageId } from './TestAttributeLineage';
import { z } from 'zod';
export const testTabularColumnLineageId = (z.string());
export const testTabularColumnLineage = z.object({
    id: testTabularColumnLineageId,
    attribute_lineage_id: testAttributeLineageId,
    created_at: z.date(),
});
export const testTabularColumnLineageInitializer = z.object({
    id: testTabularColumnLineageId.optional(),
    attribute_lineage_id: testAttributeLineageId,
    created_at: z.date().optional(),
});
export const testTabularColumnLineageMutator = z.object({
    id: testTabularColumnLineageId.optional(),
    attribute_lineage_id: testAttributeLineageId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=TestTabularColumnLineage.js.map